import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "link", "progress"]

  connect() {
    this.update = this.update.bind(this)
    this.ticking = false
    window.addEventListener("scroll", this.update, { passive: true })
    window.addEventListener("resize", this.update, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.update)
    window.removeEventListener("resize", this.update)
  }

  jump(event) {
    const sectionId = event.currentTarget.dataset.sectionId
    const section = this.sectionTargets.find((candidate) => candidate.id === sectionId)
    if (!section) return

    event.preventDefault()
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    section.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" })
    window.history.replaceState(window.history.state, "", `#${sectionId}`)
    section.querySelector("h1, h2")?.focus({ preventScroll: true })
    this.activate(sectionId)
  }

  update() {
    if (this.ticking) return

    this.ticking = true
    requestAnimationFrame(() => {
      const marker = window.innerHeight * 0.4
      let current = this.sectionTargets[0]

      this.sectionTargets.forEach((section) => {
        if (section.getBoundingClientRect().top <= marker) current = section
      })

      if (current) this.activate(current.id)
      this.ticking = false
    })
  }

  activate(sectionId) {
    const activeIndex = this.linkTargets.findIndex((link) => link.dataset.sectionId === sectionId)

    this.linkTargets.forEach((link) => {
      const active = link.dataset.sectionId === sectionId
      link.classList.toggle("is-active", active)
      if (active) {
        link.setAttribute("aria-current", "location")
      } else {
        link.removeAttribute("aria-current")
      }
    })

    const denominator = Math.max(this.linkTargets.length - 1, 1)
    const progress = Math.max(activeIndex, 0) / denominator
    if (this.hasProgressTarget) {
      this.progressTarget.style.setProperty("--section-progress", 0.18 + (progress * 0.82))
    }
  }
}
